<div class="tab-scroll-container">
  <ng-content select="cs-tab-button"></ng-content>
</div>

<!-- Scroll indicators (only on small screens) -->
@if (canScrollLeft) {
  <div class="scroll-indicator left">
    <cs-icon name="arrow-dropleft"></cs-icon>
  </div>
}
@if (canScrollRight) {
  <div class="scroll-indicator right">
    <cs-icon name="arrow-dropright"></cs-icon>
  </div>
}